import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { uiModal, uiA, uiMerge, ui, uiButton, uiFormRow, uiCheckbox, uiInputText } from 'envy-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';

ReactModal.setAppElement('#root');

export default function SyncPreConfirm({
  syncType,
  onClose,
  onConfirm,
  onSwitchSyncType,
  createdAt,
  withPublish,
  onTogglePublish,
  overrideLabels,
  onToggleOverrideLabels,
}) {
  // const [confirmation, setConfirmation] = useState('');

  const canPublish = ['CURRENT', 'INCOMING'].includes(syncType);
  const isDelete = syncType === 'DELETE';

  // const onChange = ({ currentTarget: { value } }) => setConfirmation(value);

  return (
    <ReactModal
      isOpen
      portalClassName={uiMerge([uiModal``])}
      overlayClassName={uiMerge([uiModal`__overlay`])}
      {...ui([uiModal`__modal`, uiA`overflow-hidden`])}
    >
      <div {...ui([uiModal`__header --alert`])}>
        <div {...ui([uiA`m-right-auto ellipsis`])}>Apply Synced Data from Plans</div>
        <button type="button" onClick={onClose} {...ui([uiButton`--clean --content-inverse`, uiA`m-right`])}>
          <span {...ui([uiButton`__content`])}>
            <FontAwesomeIcon icon={['fal', 'times']} />
          </span>
        </button>
      </div>
      <form onSubmit={onConfirm} {...ui([uiA`f f-column f-1-1-auto overflow-hidden h-max-100vh`])}>
        <div {...ui([uiModal`__content`, uiA`m-y-small`])}>
          <p {...ui([uiFormRow``, uiA`m-x m-top`])}>
            {`Data synced on ${moment(createdAt).format(
              'MMM D, YYYY, h:mm:ss a',
            )} from Plans has not been applied. Select one of the options below to apply your synced data.`}
          </p>
          <div {...ui([uiA`f-0-0-auto`])}>
            <ul {...ui([uiA`m-x p-none`])} style={{ listStyle: 'none' }}>
              <li>
                <label {...ui([uiFormRow``, uiA`f f-gap f-a-start font-weight-normal`])}>
                  <input
                    type="radio"
                    name="syncType"
                    value="CURRENT"
                    checked={syncType === 'CURRENT'}
                    onChange={onSwitchSyncType}
                    {...ui([uiCheckbox`--radio`])}
                  />
                  <span {...ui([uiFormRow`__label`, uiA`font-weight-normal f-1-1-auto w-max-350`])}>
                    Retain descriptions and only replace plan element updates with data from Plans.
                  </span>
                </label>
              </li>
              <li>
                <label {...ui([uiFormRow``, uiA`f f-gap f-a-start font-weight-normal`])}>
                  <input
                    type="radio"
                    name="syncType"
                    value="INCOMING"
                    checked={syncType === 'INCOMING'}
                    onChange={onSwitchSyncType}
                    {...ui([uiCheckbox`--radio`])}
                  />
                  <span {...ui([uiFormRow`__label`, uiA`font-weight-normal f-1-1-auto w-max-350`])}>
                    Replace all plan element descriptions and updates with data from Plans.
                  </span>
                </label>
                {syncType === 'INCOMING' && (
                  <label {...ui([uiFormRow``, uiA`f f-gap-small f-a-start font-weight-normal m-left-25 p-left-2`])}>
                    <input
                      type="checkbox"
                      value="LABEL"
                      checked={overrideLabels}
                      onChange={onToggleOverrideLabels}
                      {...ui([uiCheckbox`--check`])}
                    />
                    <span {...ui([uiFormRow`__label`, uiA`font-weight-normal f-1-1-auto w-max-350 italic`])}>
                      Override navigation labels with plan element descriptions
                    </span>
                  </label>
                )}
              </li>
              <li>
                <label {...ui([uiFormRow``, uiA`f f-gap f-a-start font-weight-normal`])}>
                  <input
                    type="radio"
                    name="syncType"
                    value="MANUAL"
                    checked={syncType === 'MANUAL'}
                    onChange={onSwitchSyncType}
                    {...ui([uiCheckbox`--radio`])}
                  />
                  <span {...ui([uiFormRow`__label`, uiA`font-weight-normal f-1-1-auto w-max-350`])}>
                    Choose specific plan elements for application.
                  </span>
                </label>
              </li>
              <li>
                <label {...ui([uiFormRow``, uiA`f f-gap f-a-start font-weight-normal p-top-small`])}>
                  <input
                    type="radio"
                    name="syncType"
                    value="DELETE"
                    checked={syncType === 'DELETE'}
                    onChange={onSwitchSyncType}
                    {...ui([uiCheckbox`--radio`])}
                  />
                  <span {...ui([uiFormRow`__label`, uiA`font-weight-normal f-1-1-auto w-max-350`])}>Exit and delete sync stays.</span>
                </label>
              </li>
            </ul>
            {canPublish && (
              <>
                <span {...ui([uiA`f h-1 h-min-1 border-top-light w-100% m-top-large`])} />
                <label
                  {...ui([
                    uiFormRow`--full`,
                    uiA`f-gap f-a-start f-1-1-auto text-default font-weight-normal w-max-425 m-x m-y-large p-bottom:${!withPublish}`,
                  ])}
                >
                  <input type="checkbox" checked={withPublish} onChange={onTogglePublish} {...ui([uiCheckbox`--toggle`])} />
                  <div {...ui([uiFormRow`__label --free `, uiA`f f-column`])}>
                    <span>Publish</span>
                    {withPublish && canPublish && (
                      <p {...ui([uiA`w-max-375 font-size-13 m-top-small`])}>
                        All changes will be published and made accessible to the public. This action cannot be reversed.{' '}
                        <span {...ui([uiA`color-red`])}>Are you sure?</span>
                      </p>
                    )}
                  </div>
                </label>
              </>
            )}
            {/* {isDelete && (
              <div {...ui([uiFormRow``, uiA`f f-column f-a-start m`])}>
                <p>
                  This action <span {...ui([uiA`semibold `])}>CANNOT</span> be undone. If you wish to proceed, please type DELETE (all
                  letters in upper case) to confirm.
                </p>
                <input value={confirmation} onChange={onChange} placeholder="Please type here..." {...ui([uiInputText``])} />
              </div>
            )} */}
          </div>
        </div>
        <div {...ui([uiModal`__footer`, uiA`m-top-auto`])}>
          <button
            type="submit"
            {...ui([uiButton`--red:--mint-blue:${(canPublish && withPublish) || isDelete}`, uiA`m-right m-left-auto`])}
            // disabled={isDelete && confirmation !== 'DELETE'}
          >
            <span {...ui([uiButton`__content`])}>{isDelete ? 'Delete' : `Confirm ${withPublish ? 'and Publish' : ''}`}</span>
          </button>
          <button type="button" onClick={onClose} {...ui([uiButton`--default`, uiA`m-right`])}>
            <span {...ui([uiButton`__content`])}>Cancel</span>
          </button>
        </div>
      </form>
    </ReactModal>
  );
}
